export const setNextSequenceFocusElement = (document: Document, selector: string): void => {
	const element = document?.querySelector(selector);
	if (element) {
		(element as HTMLElement).focus();
		(element as HTMLElement).blur();
	}
};
